import { t } from 'i18next';

import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';

export const OTHER_ITEMS_NAMES = {
  INTEREST_RECEIVED: 'interestReceived',
  INTEREST_PAID: 'interestPaid',
  INCOME_TAXES_PAID: 'incomeTaxesPaid',
} as const;

export const otherItemsLinkedFields = {
  [OTHER_ITEMS_NAMES.INTEREST_RECEIVED]: {
    title: t('financialPlan.projectedCashFlow.inDirect.otherItems.interestReceived'),
  },
  [OTHER_ITEMS_NAMES.INTEREST_PAID]: {
    title: t('financialPlan.projectedCashFlow.inDirect.otherItems.interestPaid'),
  },
  [OTHER_ITEMS_NAMES.INCOME_TAXES_PAID]: {
    title: t('financialPlan.projectedCashFlow.inDirect.otherItems.incomeTaxesPaid'),
  },
};

export interface IOtherItemsInitialValues {
  [OTHER_ITEMS_NAMES.INTEREST_RECEIVED]: IPeriodsTableRow;
  [OTHER_ITEMS_NAMES.INTEREST_PAID]: IPeriodsTableRow;
  [OTHER_ITEMS_NAMES.INCOME_TAXES_PAID]: IPeriodsTableRow;
}

export const otherItemsInitialValues: IOtherItemsInitialValues = {
  [OTHER_ITEMS_NAMES.INTEREST_RECEIVED]: initialPeriodsTableRow,
  [OTHER_ITEMS_NAMES.INTEREST_PAID]: initialPeriodsTableRow,
  [OTHER_ITEMS_NAMES.INCOME_TAXES_PAID]: initialPeriodsTableRow,
};